import React from "react";

import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";

import MouseOverPopover from "components/MouseOverPopover";

// MUI multiline fields render TextareaAutosize, whose ResizeObserver loop
// surfaces as a runtime error. A native textarea keeps the outlined label.
const nativeTextareaSlotProps = {
    input: {
        inputComponent: "textarea",
    },
};

const OpenAiAdsCreateFields = ({
    conversionsApiKey,
    advertiserApiKey,
    onConversionsApiKeyChange,
    onAdvertiserApiKeyChange,
    conversionsApiKeyError,
    advertiserApiKeyError,
    createPixelStatus,
    onCreatePixelStatusChange,
    createPixelQuestion,
    createPixelPopover,
}) => (
    <>
        <TextField
            className="mb-3"
            fullWidth
            multiline
            rows={4}
            name="conversions_api_key"
            label="Conversions Key"
            placeholder="Conversions Key"
            value={conversionsApiKey || ""}
            onChange={onConversionsApiKeyChange}
            error={!!conversionsApiKeyError}
            helperText={conversionsApiKeyError || ""}
            slotProps={nativeTextareaSlotProps}
        />
        <TextField
            fullWidth
            multiline
            rows={4}
            name="advertiser_api_key"
            label="Ads Management Key"
            placeholder="Ads Management Key"
            value={advertiserApiKey || ""}
            onChange={onAdvertiserApiKeyChange}
            error={!!advertiserApiKeyError}
            helperText={advertiserApiKeyError || ""}
            slotProps={nativeTextareaSlotProps}
        />
        <FormGroup className="create_pixel_tracking_question mouse-over-popover-area mouse-over-popover-checkbox tour-enable-pixel-tracking-checkbox">
            <div style={{ maxWidth: "80%" }}>
                <span style={{ fontSize: "13px" }}>
                    {createPixelQuestion ??
                        "Do you want to enable pixel tracking at the browser level too?"}
                </span>
                <MouseOverPopover text={createPixelPopover}></MouseOverPopover>
            </div>
            <Switch
                size="small"
                color="secondary"
                checked={!!createPixelStatus}
                onChange={onCreatePixelStatusChange}
            />
        </FormGroup>
    </>
);

export default OpenAiAdsCreateFields;
